import DOMPurify from 'isomorphic-dompurify';
import extractText from './extractText';

const seoScriptProps = (
  jsonLd: { raw: string },
  contentParser = (content: string) => content,
  structuredData?: string,
): Record<string, any> | null => {
  // This solution until we fully migrate the all ld+json data
  function sanitizeScriptElement(data: string | undefined) {
    if (data && DOMPurify.sanitize) {
      const sanitized = DOMPurify.sanitize(data, { ALLOWED_TAGS: ['script'], FORCE_BODY: true, RETURN_DOM: true });
      return (sanitized as Element).firstElementChild;
    }
    return null;
  }
  const newStructure =
    structuredData && `<script type='application/ld+json'>${JSON.stringify(structuredData)}</script>`;
  const scriptHTMLElement = sanitizeScriptElement(jsonLd?.raw) || sanitizeScriptElement(newStructure);
  // Temporary until fix image urls on WP
  const scriptHtmlContent = scriptHTMLElement?.firstChild
    ? extractText(contentParser(DOMPurify.sanitize(scriptHTMLElement.firstChild)).replaceAll('&amp;', '&'))
    : '';

  return (
    scriptHTMLElement && {
      ...Array.from({ length: scriptHTMLElement.attributes.length })
        // loop through script attributes to create a prop object like { class: "rank-math-schema", ...}
        // initial value is setting scriptHTMLElement (script child) to dangerouslySetInnerHTML
        .reduce(
          (acc: Record<string, any>, _curr, index) => {
            const { nodeName, nodeValue } = scriptHTMLElement.attributes[index];
            // Map HTML attributes coming from the CMS to their React DOM property names
            const propName = nodeName === 'class' ? 'className' : nodeName;
            acc[propName] = nodeValue;
            return acc;
          },
          {
            ...(scriptHTMLElement.firstChild && { dangerouslySetInnerHTML: { __html: scriptHtmlContent } }),
          },
        ),
    }
  );
};

export default seoScriptProps;
